import { Box, Button, Container, Typography } from '@mui/material';

const AboutUs = ({ setShowForm }) => {
    return (
        <Box
            component="section"
            id="about"
            sx={{
                py: { xs: 6, md: 8 },
                // background: 'linear-gradient(135deg, primary.main 0%, secondary.main 100%)',
                background: `linear-gradient(
                    135deg,
                    hsl(38 92% 50% / .05) 0%,
                    hsl(0 0% 100%) 50%,
                    hsl(262 83% 58% / .05) 100%
                    )`,
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            }}
        >
            {/* Background Circles */}
            <Box
                sx={{
                    position: "absolute",
                    top: -100,
                    left: -100,
                    // width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "primary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    bottom: -100,
                    right: -100,
                    // width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "secondary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />
            <Container maxWidth="md">
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Typography
                        variant="overline"
                        sx={{
                            color: '#3c83f6',
                            fontWeight: 600,
                            letterSpacing: 1.5,
                            mb: 2,
                            display: 'block',
                        }}
                    >
                        Mission
                    </Typography>
                    <Typography gutterBottom sx={{ fontSize: '2.25rem', lineHeight: '2.5rem', fontWeight: '700' }}>
                        Who we are
                    </Typography>
                </Box>

                <Box sx={{ textAlign: 'center', mt: 4 }}>
                    <Typography
                        sx={{
                            background: 'linear-gradient(135deg, hsl(217 91% 60%) , hsl(262 83% 58%))',
                            backgroundClip: 'text',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            fontSize: '1.875rem',
                            lineHeight: '2.25rem',
                            fontWeight: 700,
                            mb: 3,
                        }}
                    >
                        Empowering Education, Transforming Future
                    </Typography>

                    <Box sx={{ '& > p': { mb: 2 } }}>
                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                            We enhance traditional learning with modern technology to create smarter, more effective pathways. Our digital platform supports students and educators at every step, empowering them to be part of a remarkable success journey.
                        </Typography>

                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                            <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
                                learningFitbit
                            </Box>{' '}
                            empowers educational institutions to grow, stand out, and thrive among leading EdTech platforms. We deliver fast, practical solutions that tackle challenges, unlock opportunities, and redefine the future of education.
                        </Typography>
                        <Button
                            variant="contained"
                            size="large"
                            // endIcon={<CheckCircleOutlinedIcon />}
                            sx={{
                                mt: 4,
                                borderRadius: 3,
                                textTransform: "none",
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, hsl(16 100% 62%) 0%, #f59f0a 100%)',
                                color: '#fff',
                                fontSize: '0.875rem',
                                lineHeight: '1.25rem',

                            }}
                            onClick={setShowForm}
                        >
                            🎯 Transform Education with Us
                        </Button>
                    </Box>
                </Box>
            </Container >
        </Box >
    );
};

export default AboutUs;
